var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4752 2.80698C17.1225 2.12016 16.6137 1.52565 15.9895 1.0712C15.3653 0.616751 14.6433 0.315042 13.8813 0.190313C13.1194 0.0655851 12.3388 0.121315 11.6024 0.353026C10.8659 0.584737 10.194 0.985968 9.64072 1.52448L9.00022 2.11023L8.37997 1.54548C7.82799 0.996535 7.15296 0.58726 6.41099 0.351675C5.66901 0.11609 4.88152 0.0609996 4.11397 0.190982C3.35087 0.30996 2.62718 0.60931 2.00301 1.06416C1.37884 1.51902 0.872212 2.11625 0.525224 2.80623C0.0614049 3.71517 -0.100674 4.74827 0.0625122 5.75558C0.225699 6.76288 0.705658 7.69197 1.43272 8.40798L8.46247 15.65C8.53237 15.7219 8.61597 15.779 8.70834 15.818C8.8007 15.8571 8.89995 15.8772 9.00022 15.8772C9.10049 15.8772 9.19975 15.8571 9.29211 15.818C9.38448 15.779 9.46808 15.7219 9.53797 15.65L16.558 8.42148C17.288 7.70478 17.7705 6.77401 17.9355 5.76435C18.1004 4.7547 17.9392 3.71875 17.4752 2.80698Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart-filled.8fc01a72a517a60a9d2666adc358d472.svg";
export { ForwardRef as ReactComponent };